import {Exclude, Expose} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';

@Exclude()
export class HyperlinkApiModel extends AbstractApiModel {

  @Expose() public name: string;
  @Expose() public uri: string;
}
